export default __webpack_public_path__ + "static/media/005-beach.29beee45.svg";